import { useState, useEffect } from 'react';
import Store from 'store';

export const useRequireAuth = () => {
  const UserStore = Store.useUserStore();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { user, token } = UserStore;

  useEffect(() => {
    const checkAuth = async () => {
      const user = await UserStore.onReady();
      setIsLoggedIn(!!user);
      setIsChecking(false);
    };
    checkAuth();
  }, []);

  useEffect(() => {
    if (user !== undefined) {
      setIsLoggedIn(!!user);
      setIsChecking(false);
    }
  }, [user, token]);

  return {
    isLoggedIn,
    isChecking,
  };
};

